module.exports = __webpack_public_path__ + "img/idea.bc8ac243.svg";